import React from 'react'
// import {getStaticText} from '../../core/lang';
// import {getConst} from '../../core/consts';

const Banner = (props) => {
  // const lang = getStaticText(props.activeLanguage);
  // const {carLoanTypeList} = getConst(props.activeLanguage);
  return(
    <div className='sw-banner-wrap carLoan'>
      {/* <div className='sw-layout'>
        <div className='banner-content'>
          <h1 className='caption-title'>{lang.loan_banner_title}</h1>
          {/* <h4 className='caption-sub-title'>{lang.auto_loan_banner_sub_title}</h4> */}
          {/* {
            props.location.pathname === lang.auto_loan_banner_path?
            <h4 className='caption-sub-title'>{lang.auto_loan_banner_h4}</h4>
            :
            carLoanTypeList.map((row, idx) => (
              props.location.pathname === row.path?<h4 key={idx} className='caption-sub-title'>{row.head}</h4>:''
            ))
          }
        </div>
        <div className='banner-img'>
          <img alt={lang.auto_loans} src="https://soulwallet.imgix.net/static-compressed/assets/list/carloans3.png?auto=compress"/>
        </div>
      </div> */}
    </div>
  )
}

export default Banner



// WEBPACK FOOTER //
// ./src/components/autoLoans/BannerAutoLoan.js